import React from "react";
import { Avatar, Typography } from "antd";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
const { Text } = Typography;

const EmployeeLink = (props) => {
  const { record, branch } = props;
  let location = useLocation();
  const letter = record && record.first_name.charAt(0);
  const name = record && record.surename + " " + record.first_name;
  const isAdmin = location.pathname.includes("admin");
  const linkPath =
    isAdmin && record
      ? `/admin/employees/${record.id}`
      : record && `/branches/${branch}/employees/${record.id}`;

  return record ? (
    <div>
      {record.avatar_url ? (
        <Avatar src={record.avatar_url} />
      ) : (
        <Avatar style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}>
          {letter}
        </Avatar>
      )}
      <Link
        style={{ color: "inherit" }}
        to={{
          pathname: linkPath,
        }}
      >
        <Text
          ellipsis={true}
          style={{ padding: "0 10px", textDecoration: "underline" }}
        >
          {name}
        </Text>
      </Link>
    </div>
  ) : (
    <div />
  );
};

export default EmployeeLink;
